import React, {
  Fragment,
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'

import Highcharts from 'highcharts/highmaps'
import noDataToDisplay from 'highcharts/modules/no-data-to-display'
import HighchartsReact from 'highcharts-react-official'
import Grid from '@material-ui/core/Grid'
import { GridItem } from 'Components/Page/StatsPageWrapper'
import Loader from '../../../StatsOverview/components/HighchartsCharts/components/Loader'
import ChartHeader from '../ChartHeader'
import { chartOptions } from './options'
import {
  filterDataByRange,
  getDifferences,
  getParametersFilters,
  numberToThousand,
} from '../utils'
import {
  dataToOptions,
  formatData,
  renderMailDistributionGraphPopup,
} from './utils'
// eslint-disable-next-line no-unused-vars
import mapData from './mapData'

noDataToDisplay(Highcharts)

const separators = Highcharts.geojson(
  Highcharts.maps['countries/us/us-all'],
  'mapline',
)

const MailDistributionGraph = ({
  deliverabilityReport: { nodes: reportData },
}) => {
  const [options, setOptions] = useState(chartOptions)
  const formatedData = useMemo(() => formatData(reportData), [reportData])
  const dates = formatedData.dates
  const [form, setForm] = useState({
    from: dates[0],
    to: dates[dates.length - 1],
  })
  const dataKeys = Object.keys(formatedData).filter(item => item !== 'dates')

  useEffect(() => {
    const optionsData = dataToOptions({
      data: dataKeys,
      hashMap: formatedData,
      firstDate: form.from,
      lastDate: form.to,
    })

    setOptions(prev => ({
      ...prev,
      series: [
        {
          data: optionsData,
          name: 'USA',
          dataLabels: {
            enabled: true,
            format: '{point.properties.postal-code}',
          },
        },
        {
          type: 'mapline',
          data: separators,
          color: 'silver',
          enableMouseTracking: false,
          animation: {
            duration: 500,
          },
        },
      ],
      tooltip: {
        useHTML: true,
        formatter: function() {
          const key = this.point['hc-key'].replace('us-', '')
          const data = formatedData[key]
          const totalSentPercent = optionsData.find(
            item => item['hc-key'] === this.point['hc-key'],
          ).value

          const selectedDates = Object.keys(data.resultsByDate)

          const rangeDatesList = selectedDates.slice(
            selectedDates.indexOf(form.from),
            selectedDates.indexOf(form.to) + 1,
          )
          const filteredDataByRange = filterDataByRange(
            rangeDatesList,
            data.resultsByDate,
          )
          const differences = getDifferences(filteredDataByRange)
          const delivered = differences.reduce((acc, item) => acc + item, 0)
          const averageSpeed = Math.trunc(delivered / differences.length)
          return renderMailDistributionGraphPopup({
            state: this.key,
            delivered: numberToThousand(delivered),
            totalSentPercent,
            averageSpeed,
          })
        },
      },
    }))
  }, [form.to, form.from])

  const { from, to } = getParametersFilters({
    filterOptions: dates,
    formFrom: form.from,
    formTo: form.to,
  })

  const handleFormChange = useCallback(item => {
    if (item.isDirty) {
      setForm(prev => ({ ...prev, [item.name]: item.value }))
    }
  }, [])
  return (
    <div>
      <h1>Mail Distribution</h1>
      <GridItem>
        <Suspense fallback={<Loader />}>
          <Grid container>
            <Grid item xs={12}>
              {dates.length ? (
                <Fragment>
                  <ChartHeader
                    form={form}
                    handleFormChange={handleFormChange}
                    from={from}
                    to={to}
                  />
                </Fragment>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                constructorType={'mapChart'}
              />
            </Grid>
          </Grid>
        </Suspense>
      </GridItem>
    </div>
  )
}

export default MailDistributionGraph



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/Charts/MailDistributionGraph/index.js